import React from "react";
import "./SunScreenTab.css";
import Text from "src/components/Text/Text";
import { useConfiguration } from "src/contexts/ConfigurationContext";
import HorizontalSwitch from "src/components/Input/HorizontalSwitch/HorizontalSwitch";
import RadioBlocksExtended from "src/components/Input/RadioBlocksExtended/RadioBlocksExtended";
import { Lights, SunScreen } from "src/types/configuration";
// @ts-ignore
import isEqual from "lodash/isEqual";
import SelectUnselectExtended from "src/components/SelectUnselectExtended/SelectUnselectExtended";

const sunScreenColors = [
  {
    id: 0,
    name: "Standaard Grijs",
    // imageUrl: "./images/poer.png",
    color: "#eeeeee",
    value: "default",
    price: 0,
    carouselImages: [`${process.env.PUBLIC_URL}/images/default.jpg`],
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    id: 1,
    name: "LightIvory, RAL 1015",
    // imageUrl: "./images/poer.png",
    color: "#e6d2b5",
    value: "sand",
    price: 0,
    carouselImages: [`${process.env.PUBLIC_URL}/images/ral1015.jpg`],
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    id: 2,
    name: "PastelBlue, RAL 5024",
    // imageUrl: "./images/poer.png",
    color: "#6093ac",
    value: "sky",
    price: 0,
    carouselImages: [`${process.env.PUBLIC_URL}/images/ral1015.jpg`],
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    id: 3,
    name: "TarpaulinGrey, RAL 7010",
    // imageUrl: "./images/poer.png",
    color: "#585c56",
    value: "dark",
    price: 0,
    carouselImages: [`${process.env.PUBLIC_URL}/images/ral5024.jpg`],
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    id: 4,
    name: "AgateGrey, RAL 7038",
    // imageUrl: "./images/poer.png",
    color: "#B4B8B0",
    value: "gray",
    price: 0,
    carouselImages: [`${process.env.PUBLIC_URL}/images/ral7038.jpg`],
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    id: 5,
    name: "BlackBrown, RAL 8022",
    // imageUrl: "./images/poer.png",
    color: "#211F20",
    value: "black",
    price: 0,
    carouselImages: [`${process.env.PUBLIC_URL}/images/ral8022.jpg`],
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
];

const carouseltop = [
  `${process.env.PUBLIC_URL}/images/ver_sun_default.jpg`,
  `${process.env.PUBLIC_URL}/images/ver_sun_yellow.jpg`,
  `${process.env.PUBLIC_URL}/images/ver_sun_blue.jpg`,
  `${process.env.PUBLIC_URL}/images/ver_sun_darkgray.jpg`,
  `${process.env.PUBLIC_URL}/images/ver_sun_gray.jpg`,
  `${process.env.PUBLIC_URL}/images/ver_sun_black.jpg`,
];

const carouselbot = [
  `${process.env.PUBLIC_URL}/images/ver_sunund_default.jpg`,
  `${process.env.PUBLIC_URL}/images/ver_sunund_yellow.jpg`,
  `${process.env.PUBLIC_URL}/images/ver_sunund_blue.jpg`,
  `${process.env.PUBLIC_URL}/images/ver_sunund_darkgray.jpg`,
  `${process.env.PUBLIC_URL}/images/ver_sunund_gray.jpg`,
  `${process.env.PUBLIC_URL}/images/ver_sunund_black.jpg`,
];

const lights = [
  {
    id: 0,
    name: "Geen verlichting",
    value: "none",
    price: 0,
    // color: "#444444",
    imageUrl: `${process.env.PUBLIC_URL}/images/empty.png`,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    id: 1,
    name: "In elke dakligger",
    value: "all",
    price: 0,
    imageUrl: `${process.env.PUBLIC_URL}/images/ver_lights_all.png`,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    id: 2,
    name: "In elke 2e dakligger",
    value: "some",
    price: 0,
    imageUrl: `${process.env.PUBLIC_URL}/images/ver_lights_some.png`,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
];

const SunScreenTab: React.FC = () => {
  const { state, setSunScreen, setLights, configuration } = useConfiguration();

  const { configurator } = useConfiguration();

  lights.map(
    (item) =>
      (item.price = configuration.calculationService.getLight(item.value))
  );

  const handleSunScreenCoverChange = (value: string) => {
    if (state.sunScreen.cover !== value) {
      const temp = { ...state.sunScreen };
      temp.cover = value;
      setSunScreen({ ...temp });
    }
  };

  const getSunScreen = () => {
    const screen = state.sunScreen;
    return !screen.enabled ? "none" : screen.top ? "top" : "bottom";
  };

  const getLights = () => {
    const lights = state.lights;
    return !lights.enabled ? "none" : lights.everyLigger ? "all" : "some";
  };

  const handleSunScreen = (value: string) => {
    let temp: SunScreen = { ...state.sunScreen };

    if (value === "top")
      temp = { ...state.sunScreen, enabled: true, top: true };
    else if (value === "bottom")
      temp = { ...state.sunScreen, enabled: true, top: false };
    else temp = { ...state.sunScreen, enabled: false };

    if (!isEqual(state.sunScreen, temp)) setSunScreen({ ...temp });
  };

  const handleLights = (value: string) => {
    let temp: Lights = { ...state.lights };

    if (value === "all")
      temp = {
        ...state.lights,
        enabled: true,
        everyLigger: true,
        lightsOn: true,
      };
    else if (value === "some")
      temp = {
        ...state.lights,
        enabled: true,
        everyLigger: false,
        lightsOn: true,
      };
    else temp = { ...state.lights, enabled: false };

    if (!isEqual(state.lights, temp)) setLights({ ...temp });
  };

  const SunScreenComponent = () => {
    const sunScreens = [
      {
        id: 0,
        name: "Geen zonwering",
        value: "none",
        imageUrl: `${process.env.PUBLIC_URL}/images/empty.png`,
        price: 0,
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      },
      {
        id: 1,
        name: "Bovenop het dak",
        imageUrl: `${process.env.PUBLIC_URL}/images/ver_sunscreen_top.png`,
        value: "top",
        price: 0,
        carouselImages: carouseltop,
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",

        component: () => (
          <ColorComponent parentIsSelected={getSunScreen() === "top"} />
        ),
      },
      {
        id: 2,
        name: "Onder het dak",
        imageUrl: `${process.env.PUBLIC_URL}/images/ver_sunscreen_bottom.png`,
        value: "bottom",
        price: 0,
        carouselImages: carouselbot,
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",

        component: () => (
          <ColorComponent parentIsSelected={getSunScreen() === "bottom"} />
        ),
      },
    ];

    sunScreens.map((item) => {
      if (item.value !== "none")
        item.price = configuration.calculationService.getSunscreen();
    });

    const handleSunScreenColorChange = (value: string) => {
      if (state.sunScreen.cover !== value) {
        const temp = { ...state.sunScreen };
        temp.color = value;
        setSunScreen({ ...temp });
      }
    };

    const ColorComponent = ({
      parentIsSelected,
    }: {
      parentIsSelected: boolean;
    }) => {
      return (
        <>
          {/* <Text content="Bedekkingsgraad" /> */}
          <Text content="Zonwering gesloten tonen in 3D?" />
          <HorizontalSwitch
            value={state.sunScreen.cover}
            values={[
              { id: 0, label: " 0%", value: "0" },
              { id: 1, label: " 50%", value: "50" },
              { id: 2, label: " 100%", value: "100" },
            ]}
            onChange={handleSunScreenCoverChange}
          />
          <RadioBlocksExtended
            blocks={sunScreenColors}
            value={state.sunScreen.color}
            onChange={handleSunScreenColorChange}
            className={"inner_child"}
            parentIsSelected={parentIsSelected}
          />
        </>
      );
    };

    return (
      <>
        <RadioBlocksExtended
          blocks={sunScreens}
          value={getSunScreen()}
          onChange={handleSunScreen}
        />
        {/* {state.sunScreen.enabled && (
          <>
            <Text content="Coverage" />

            <HorizontalSwitch
              value={state.sunScreen.cover}
              values={[
                { id: 0, label: " 0%", value: "0" },
                { id: 1, label: " 50%", value: "50" },
                { id: 2, label: " 100%", value: "100" },
              ]}
              onChange={handleSunScreenCoverChange}
            />
          </>
        )} */}
      </>
    );
  };
  const LightComponent = () => {
    return (
      <>
        <RadioBlocksExtended
          blocks={lights}
          value={getLights()}
          onChange={handleLights}
          className="inner_child"
        />
      </>
    );
  };

  const handleSunScreenOn = (enabled: boolean) => {
    if (state.sunScreen.enabled !== enabled)
      setSunScreen({ ...state.sunScreen, enabled: enabled });
  };

  const handleLightsEnabled = (enabled: boolean) => {
    if (state.lights.enabled !== enabled)
      setLights({ ...state.lights, enabled: enabled });
  };

  return (
    <div className="sunscreen-tab">
      <SelectUnselectExtended
        name="Zonwering"
        imageUrl={`${process.env.PUBLIC_URL}/images/ver_sunscreen_top.png`}
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod "
        isSelected={state.sunScreen.enabled}
        onSelect={() => true}
        onUnselect={() => false}
        // componentIsVisible={state.sunScreen.enabled}
        Component={SunScreenComponent}
        carouselImages={[...carouseltop, ...carouselbot]}
        selectedNames={
          !state.sunScreen.top ? `Onder het dak` : `Bovenop het dak`
        }
      />
      <SelectUnselectExtended
        name="Verlichting"
        imageUrl={`${process.env.PUBLIC_URL}/images/ver_lights_all.png`}
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
        isSelected={state.lights.enabled}
        // onSelect={() => true}
        onSelect={() => {
          if (!state.lights.lightsOn)
            setLights({ ...state.lights, lightsOn: true });
        }}
        // onUnselect={() => true}
        onUnselect={() => {
          // setLights({ ...state.lights, lightsOn: false });
        }}
        // componentIsVisible={state.lights.enabled}
        Component={LightComponent}
        selectedNames={
          state.lights.everyLigger
            ? `In elke dakligger`
            : `In elke 2e dakligger`
        }
        carouselImages={lights
          .map((i) => i.imageUrl)
          .filter((i) => !i.includes("empty"))}
      />

      {/* <RadioBlocksExtended
        blocks={[
          {
            id: 1,
            name: "Verlichting",
            value: "screen",
            price: 0,
            imageUrl: `${process.env.PUBLIC_URL}/images/ver_lights_all.png`,
            description:
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
            component: LightComponent,
          },
        ]}
        value={" "}
        onChange={() => null}
        // className={"inner_child"}
      /> */}
    </div>
  );
};

export default SunScreenTab;
